// extracted by mini-css-extract-plugin
export default {"content":"InfoSalaryProcess_content__7BAhR","fields":"InfoSalaryProcess_fields__9hBeY"};